import { AuthenticationCompletedComponent } from 'auth/authentication-completed.component';
import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { ProductsComponent } from 'component/products.component';
import { ProductDetailsComponent } from 'component/details/product-details.component';
import { AddRevisionComponent } from 'component/details/add/add-revision.component';
import { RequirementIntakeComponent } from 'component/details/requirement-intake/requirement-intake.component';
import { ForbiddenComponent } from 'error/forbidden/forbidden.component';
import { ProductResolver } from 'component/details/product-resolver';
import { ManufacturerResolver } from 'component/manufacturer-resolver';
import { RevisionResolver } from 'component/details/requirement-intake/revision-resolver';
import { DeclaredCompliantComponent } from 'component/self-declaration/declared-compliant.component';
import { SelfDeclarationComponent } from 'component/self-declaration/self-declaration.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ManufacturerDetailsComponent } from 'manufacturer/manufacturer-details.component';
import { LicenseAgreementComponent } from 'app/license/license-agreement.component';
import { LicenseAgreementConfirmedGuard } from 'app/license-agreement-confirmed-guard';
import { ManufacturerExistsGuard } from 'app/manufacturer-exists-guard';
import { AboutComponent } from 'app/about/about.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [
      AutoLoginPartialRoutesGuard,
      LicenseAgreementConfirmedGuard,
      ManufacturerExistsGuard,
    ],
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'license',
    component: LicenseAgreementComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'manufacturer',
    component: ManufacturerDetailsComponent,
    canActivate: [AutoLoginPartialRoutesGuard, LicenseAgreementConfirmedGuard],
  },
  {
    path: 'products',
    canActivate: [
      AutoLoginPartialRoutesGuard,
      LicenseAgreementConfirmedGuard,
      ManufacturerExistsGuard,
    ],
    data: {
      breadcrumbId: 'products',
      breadcrumbIcon: 'factory',
    },
    resolve: {
      Manufacturer: ManufacturerResolver,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ProductsComponent,
      },
      {
        path: ':productId',
        data: {
          breadcrumbId: 'revisions',
          breadcrumbIcon: 'edit_document',
          breadcrumbLabelPrefixKey: 'model.component.singular',
        },
        resolve: {
          Product: ProductResolver,
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ProductDetailsComponent,
          },
          {
            path: 'add',
            component: AddRevisionComponent,
          },
          {
            path: ':revisionId',
            data: {
              breadcrumbId: 'intakes',
              breadcrumbIcon: 'list',
              breadcrumbLabelPrefixKey: 'model.productRevision.singular',
            },
            resolve: {
              Revision: RevisionResolver,
            },
            children: [
              {
                path: 'declared-compliant',
                component: DeclaredCompliantComponent,
                data: { section: 'declared-compliant' },
                resolve: {
                  Revision: RevisionResolver,
                },
              },
              {
                path: '',
                component: RequirementIntakeComponent,
                children: [
                  {
                    path: 'self-declaration',
                    component: SelfDeclarationComponent,
                    data: { section: 'self-declaration' },
                  },
                ],
              },
              {
                path: '',
                pathMatch: 'full',
                component: RequirementIntakeComponent,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
  },
  {
    path: 'auth',
    component: AuthenticationCompletedComponent,
  },
  {
    path: 'share/:shareKey',
    component: DeclaredCompliantComponent,
    canActivate: [AutoLoginPartialRoutesGuard],
  },

  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];
